// middleware/api.js
import { callApi } from './api'

export const API_POST = Symbol('API POST');

const postApi =  store => next => action => {

  const callApiPost = action[API_POST];

  // So the middleware doesn't get applied to every single action
  if (typeof callApiPost === 'undefined') {
    return next(action)
  }

  // some of our API calls are scoped to an ID (for example song stats)
  // to support this callApiPost is checked for an 'id' which is always
  // attached to the action that is generated on success
  // that id will simply be 'undefined' if the callApiPost action doesn't
  // have a unique 'id'
  let { payload, shouldDispatch, endpoint, types, authenticated, betaEndpoint, alphaEndpoint } = callApiPost;
  const [ requestType, successType, errorType ] = types;

  // allows us to make decisions based on the state of the application
  //  read: http://blog.isquaredsoftware.com/2017/01/idiomatic-redux-thoughts-on-thunks-sagas-abstraction-and-reusability/
  // I'm totally open to a better solution here but I can't spend any more time on this
  //  it's time for a "good enough" solution
  if ( ! shouldDispatch || ! shouldDispatch(store)) {
    return 0;
  }

  store.dispatch({type: requestType, payload: payload});

  const fetchConfig = {
    body: JSON.stringify(payload),
    headers: {
      'content-type': 'application/json'
    },
    method: 'POST',
    mode: 'cors'
  };

  // Passing the authenticated boolean back in our data will let us distinguish between normal and secret quotes
  return callApi(endpoint, authenticated, fetchConfig, betaEndpoint, alphaEndpoint).then(
    // we package in the id to the action, undefined if it wasn't specified
    response =>
      next({
        response: response,
        payload: payload,
        type: successType,
        authenticated,
        receivedAt: Date.now()
      }),
    error => next({
      response: error,
      payload: payload,
      type: errorType,
      authenticated,
      receivedAt: Date.now()
    })
  )
}

export default postApi